import { createSetting } from '@shopex/finder'
import { batchDelete, registerDelete } from '../api'
import { useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'

export const commonAction = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '提交', key: 'save', type: 'primary', size: 'default' }
]

export const goodsTableSetting = (vm) => createSetting({
  search: [],
  columns: [
    { name: '商品ID', key: 'rel_id', width: 150 },
    {
      name: '商品名称',
      key: 'item_name',
      minWidth: 150
    }
  ],
  actions: [
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          console.log("🚢 ~ 当前打印的内容 ~ rows:", rows);
          let ids = rows.map(row => row.id)
          await batchDelete({ ids })
          vm.$message.success('删除成功')
          vm.refresh()
        }
      }
    }
  ]
})


export const shopTableSetting = (vm) => createSetting({
  search: [],
  columns: [
    { name: '店铺Apple ID', key: 'shop_code', width: 150 },
    {
      name: '店铺名称',
      key: 'name',
      minWidth: 150
    },
    {
      name: '所属经销商',
      key: 'dealer_name',
      minWidth: 150
    }
  ],
  actions: [
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          console.log("🚢 ~ 当前打印的内容 ~ rows:", rows);
          let ids = rows.map(row => row.id)
          await batchDelete({ ids })
          vm.$message.success('删除成功')
          vm.refresh()
        }
      }
    }
  ]
})


export const welcomeTableSetting = (vm) => createSetting({
  search: [],
  columns: [
    { name: '欢迎语名称', key: 'template_title', width: 150 },
    {
      name: '描述',
      key: 'template_describe',
      minWidth: 150
    },
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          console.log("🚢 ~ 当前打印的内容 ~ rows:", rows);
          useDialog(null, {
            title: `添加欢迎语`,
            width: '30%',
            infoData: rows[0],
            component: () => import('../comps/create.vue'),
            actions: commonAction
          }).then((arg) => {
            if (arg) {
              vm.refresh()
            }
          })
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          let ids = rows.map(row => row.id)
          await registerDelete({ ids })
          vm.$message.success('删除成功')
          vm.refresh()
        }
      }
    },
    {
      name: '模版配置',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `配置模版信息`,
            width: '60%',
            templateId: rows[0].id,
            component: () => import('../comps/info-template.vue'),
            actions: commonAction
          }).then((arg) => {
            if (arg) {
              vm.refresh()
            }
          })
        }
      }
    }
  ]
})

